import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicGraphqlBaseQuery } from '@vs/rtk/utils';
import { rtkCacheTTL } from '@vs/utils/constants';

import { referenceOfMeta } from './init';

export const VsSubscriptionGraphqlApiBase = createApi({
  reducerPath: 'vsSubscriptionGraphqlApi',
  baseQuery: dynamicGraphqlBaseQuery(referenceOfMeta),
  endpoints: () => ({}),
  tagTypes: [],
  keepUnusedDataFor: rtkCacheTTL.normal,
  refetchOnMountOrArgChange: rtkCacheTTL.normal,
  serializeQueryArgs: ({ queryArgs, endpointName }) => {
    const userId = referenceOfMeta._getUserIdFunc?.() || null;
    const baseKey = `${endpointName}(${JSON.stringify(queryArgs)})`;
    return userId ? `${baseKey}-user:${userId}` : baseKey;
  },
});
